export const SET_ORDER ='SET_ORDER'
export const GET_MANAGED_EQUIPMENT_ITEM_DETAILS ='GET_MANAGED_EQUIPMENT_ITEM_DETAILS'
export const SET_MANAGED_EQUIPMENT_ITEM_DETAILS = 'SET_MANAGED_EQUIPMENT_ITEM_DETAILS'
export const SHOW_CATALOG_ITEM_DETAILS ='SHOW_CATALOG_ITEM_DETAILS'